<template>
    <svg class="chevron" width="20" height="20" viewBox="0 0 20 20" stroke="#323030" fill="none">
        <g id="Chevron">
            <path
                id="shape"
                d="M8.33203 14.1668L12.4987 10.0002L8.33203 5.8335"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </g>
    </svg>
</template>

<script>
export default {
    name: "ChevronIcon"
}
</script>

<style lang="sass" scoped>

</style>
